const SUBMIT_TYPE = {
    WITHOUT: 'without_submit_void',
    VOID: 'submit_void',
    VOID_NO_BODY: 'confirm_void_no_body',
    CARD_DATE: 'get_bin_info'
}

export default SUBMIT_TYPE
